import darkLogo from "../assets/images/gaiapowered_logo_dark.svg"
import lightLogo from "../assets/images/gaiapowered_logo_light.svg"

interface LogoProps {
  variant?: 'light' | 'dark'
  className?: string
}

/**
 * Logo component that displays the appropriate logo variant
 * - 'light' variant: For dark backgrounds (uses light-colored logo)
 * - 'dark' variant: For light backgrounds (uses dark-colored logo)
 */
const Logo = ({ variant = 'dark', className = '' }: LogoProps) => {
  const logoSrc = variant === 'light'
    ? lightLogo
    : darkLogo

  return (
    <img
      src={logoSrc}
      alt="Gaia Powered"
      className={`h-12 w-auto ${className}`}
    />
  )
}

export default Logo
